import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Grid, GridApi } from '@instinet-analytics/semantic-ui-components';
import React, { useState } from 'react';
import { Button } from '@instinet-analytics/semantic-ui-components';
import { ValueGetterParams } from 'ag-grid-community';
import { isValueWithInterpolation } from 'utils/interpolation';
import { DateTime } from 'luxon';

export interface WidgetPanelGridProps<T> {
    data: T[];
    getRowDataId: (i: T) => string;
    csvFileName: string;
    colDefs?: ColDef[];
    style?: React.CSSProperties;
    onSelectedRowIdsChanged?: (rowDataIds: string[]) => void;
}

export function WidgetPanelGrid<T>(props: WidgetPanelGridProps<T>) {
    const {
        data,
        getRowDataId,
        csvFileName,
        colDefs: colDefsProps,
        style,
        onSelectedRowIdsChanged,
    } = props;

    const [gridApi, setGridApi] = useState<GridApi | undefined>(undefined);

    if (data.length === 0) {
        return <div className="widget-panel">No Data</div>;
    }

    const onGridReady = (args: GridApi) => {
        setGridApi(args);
    };

    const onClickExport = () => {
        if (gridApi) {
            gridApi.exportDataAsCsv(csvFileName);
        }
    };

    const colDefs: ColDef[] =
        colDefsProps ||
        Object.keys(data[0] as object).map((key) => {
            return {
                field: key,
                width: 120,
                resizable: true,
                colId: key,
            };
        });

    function interpValueGetter(params: ValueGetterParams) {
        const value = params.data[params.colDef.field!];
        if (isValueWithInterpolation(value)) {
            return `${value.value.toString()} ${
                value.isInterpolated ? ' (interpolated)' : ''
            }`;
        }
        if (value instanceof Date) {
            return DateTime.fromJSDate(value).toFormat('yyyy-MM-dd HH:mm:ss');
        }
        return value;
    }
    for (const colDef of colDefs) {
        colDef.valueGetter = interpValueGetter;
    }

    return (
        <div className="WidgetPanelGrid widget-panel" style={style}>
            <Button onClick={onClickExport} size="mini">
                Export CSV
            </Button>
            <Grid<T>
                columnDefs={colDefs}
                rowData={data}
                getRowDataId={getRowDataId}
                onGridReady={onGridReady}
                onSelectedRowIdsChanged={onSelectedRowIdsChanged}
            />
        </div>
    );
}
